import { createEffect, onCleanup } from 'solid-js';

import { initPalSdk, cleanupPalSdk, PalConfig } from '~/cast/lib';

export function createInitPalSdkEffect(
  getConfig: () => PalConfig | undefined,
  events?: { onShutdown?: () => void },
) {
  let alreadyInitialized = false;

  createEffect(() => {
    const config = getConfig();
    if (!config) return;

    if (import.meta.hot && import.meta.env.MODE === 'development') {
      const hmrData = import.meta.hot.data as Record<string, unknown>;

      if (hmrData.palAlreadyInitialized) return;
      hmrData.palAlreadyInitialized = true;
    }

    if (alreadyInitialized) return;

    alreadyInitialized = true;
    initPalSdk(config);
  });

  onCleanup(() => {
    cleanupPalSdk();
    events?.onShutdown?.();
  });
}
